'use strict';

class SubscriptionsTotalPageController {
  constructor($scope,
              $q,
              $filter,
              DashboardDataProvider) {
    const $t = $filter('translate');
    const currentDateFormat = $t('dash.panel.currentDateFormat');
    var initial = true;

    angular.extend($scope, {
      getData: getData
    });

    function getData(startDate, endDate) {
      return DashboardDataProvider.getSubscriptions(startDate, endDate)
        .then((reportInfo) => {

          if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
            return [];
          }

          const subscriptionIds = reportInfo.dictionary
            .filter(si => si.id !== 0) // except "No Subscription" entry (always have id=0). Btw id here is actual subscription ID.
            .map(si => JSON.stringify(si.id));
          // NOTE sometimes `id` in `dictionary[].id` and `id` in `executions[].data[].id` may have different format (string/number). We should report such cases to Server Team.

          let data = reportInfo.executions
            .slice()
            .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
            .map(execution => ({
              x: execution.executionDateMs,
              y: execution.data?.reduce((acc, e) =>
                subscriptionIds.includes(JSON.stringify(e.id))
                  ? acc + parseInt(e.value)
                  : acc, 0) || 0
            }));

          if (initial) {
            getLastMeasurement(data[data.length - 1]);
            initial = false;
          }

          return [
            {
              data: data,
              label: $t('dash.panel.reports.subscriptionsTotal.dashboardTitle')
            }
          ];
        });
    }

    // Get last measurement from initial call
    function getLastMeasurement(data) {
      if (!data) {
        return;
      }

      let info = [];
      for (let [key, value] of Object.entries(data)) {
        let timestamp = key === 'x';
        info.push({
          icon: timestamp ? 'clock' : 'chart-line',
          name: timestamp ? $t('dash.panel.reports.lastMeasured') : $t('dash.panel.reports.lastTotal'),
          value: timestamp ? $filter('date')(value, currentDateFormat) : value,
        });
      }
      $scope.lastMeasurement = info;
    }
  }
}

export default angular
  .module('main.dashboard.subscriptionsTotalPage.controller', [])
  .controller('SubscriptionsTotalPageController', SubscriptionsTotalPageController)
  .name;
